import * as React from 'react';

export interface ProjectActionToolbarComponentProps {
  user: boolean;
  interested: boolean;
  allowInvest: boolean;
  closedProject: boolean;
  interest: () => void;
  invest: () => void;
  login: () => void;
  register: () => void;
}

class ProjectActionToolbarComponent extends React.PureComponent<ProjectActionToolbarComponentProps> {
  public render(): React.ReactNode {
    return (
      <section>
        <div className="gap-20"/>
        {this.renderProjectActionToolbar(this.props.interested, this.props.allowInvest, this.props.user)}
        <div className="gap-20"/>
      </section>
    );
  }

  private renderProjectActionToolbar(interested: boolean, allowInvest: boolean, user: boolean): React.ReactNode {
    if (user) {
      if (!this.props.closedProject) {
        return (
          <section className="margin-l-30">
            {interested ?
              <button
                className="btn btn-primary margin-r-10"
                onClick={() => this.props.interest()}
              >
                Me interesa
              </button> : ''
            }
            {allowInvest ?
              <button
                className="btn btn-secondary"
                onClick={() => this.props.invest()}
              >
                Invertir
              </button> : ''
            }
          </section>
        );
      } else {
        return null;
      }
    } else if (!this.props.closedProject && this.props.register) {
      return (
        <section className="margin-l-30">
          <button
            key="signup"
            className="btn btn-secondary"
            onClick={() => this.props.register()}
          >
            Regístrate para invertir
          </button>
        </section>
      );
    }

    return null;
  }
}

export default ProjectActionToolbarComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/action-toolbar/ProjectActionToolbar.component.tsx